//src/components/ToggleSwitch.jsx
import React, { useCallback } from "react";

const ToggleSwitch = ({ label, value, onChange }) => {
  // ✅ Robust: always pass the computed next value to parent
  const handleToggle = useCallback(
    (next) => {
      if (typeof onChange === "function") onChange(Boolean(next));
    },
    [onChange]
  );

  const onClick = useCallback(() => {
    handleToggle(!value);
  }, [handleToggle, value]);

  const onKeyDown = useCallback(
    (e) => {
      // ✅ Accessibility + robustness (no accidental scroll)
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleToggle(!value);
      }
    },
    [handleToggle, value]
  );

  return (
    <label style={styles.container}>
      <span style={styles.label}>{label}</span>

      {/* ✅ button-like semantics without changing shape/size */}
      <div
        role="switch"
        aria-checked={!!value}
        tabIndex={0}
        style={{
          ...styles.switch,
          backgroundColor: value ? "#f0f4ff" : "#f5f5f5",
        }}
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        <div
          style={{
            ...styles.ball,
            left: value ? "21px" : "1px",
          }}
        />
      </div>
    </label>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    cursor: "pointer",
    userSelect: "none",
  },
  label: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#fff",
  },
  switch: {
    width: "42px",
    height: "22px",
    borderRadius: "22px",
    position: "relative",

    // ✅ Smooth + no flicker
    transition: "background-color 200ms ease",
    willChange: "background-color",

    boxSizing: "border-box",
    outline: "none",
    WebkitTapHighlightColor: "transparent",
  },
  ball: {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    position: "absolute",
    top: "2px",

    // ✅ Smooth movement (GPU-friendly)
    transition: "left 180ms cubic-bezier(0.2, 0.8, 0.2, 1)",
    willChange: "left",
    transform: "translateZ(0)",

    left: "1px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.4)",
  },
};

export default ToggleSwitch;
